import type {ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const RecaptchaProvider = ({ recaptchaKey, children }: { recaptchaKey: string; children: ReactNode }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaKey}
      scriptProps={{
        async: false, // optional, default to false,
        defer: true, // optional, default to false
        appendTo: 'body', // optional, default to "head", can be "head" or "body",
        nonce: undefined,
      }}>
      {children}
    </GoogleReCaptchaProvider>
  );
};
